<template>
    <v-dialog width="600" v-model="openProgramRpDialog" persistent>
        <v-card class="">
            <v-toolbar tile flat dark class="bg-gradient">
                <v-btn x-large depressed color="transparent" class="ml-2" dark @click.native="$emit('close')"><v-icon small class="mr-2" >$prev</v-icon> {{ $t('back') }}</v-btn>
                <v-spacer></v-spacer>
                <v-toolbar-title>{{$t('confirmation')}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text class="mt-6">
                <h5 class="text-center">{{ $t('campaign_to_program') }} :</h5>
                <v-alert border='left' class="mb-0 mt-3" color="info" dark text  v-if="retroplanning.type != 'MISSION'">
                    <span v-html="$t('program_rp_confirmation_reminder')"></span>
                </v-alert>
                <v-alert border='left' class="mb-0 mt-3" color="error" dark text :icon="'$warning_s'" dense v-if="(retroplanning.config.contact_number) == 0">
                    <span v-html="$t('noContactToSend')"></span>
                </v-alert>
                <v-alert border='left' class="mb-0 mt-3" color="warning" dark text :icon="'$warning_s'" dense v-if="retroplanning.sousType == 'campSMSconversational' && smsConvWrongDate">
                    <span v-html="$t('smsConvDateInPastAlert')"></span>
                </v-alert>
                <v-alert border='left' class="mb-0 mt-3" color="error" dark text :icon="'$warning_s'" dense v-if="retroplanning.sousType == 'campRCSout' && !asAgent">
                    <span v-html="$t('noRcsAgent')"></span>
                </v-alert>
                <v-alert border="left" class="mb-0 mt-3" color="warning" dark text :icon="'$warning_s'" dense v-if="smsSenderInvalid">
                    <span v-html="$t('invalidSenderSmsLength')"></span>
                </v-alert>
                <v-row class="mt-2">
                    <v-col cols="12">
                        <ul class="black--text">
                            <li><b>{{ $t('campaign') }} :</b> {{ retroplanning.name }}</li>
                            <li>
                                <b>{{ $t('planned_date') }} : </b>
                                <span v-if="retroplanning.sousType == 'campSMSconversational' && smsConvWrongDate">{{ nextDay }}</span>
                                <span v-else-if="new Date(retroplanning.config.date_start) > new Date()"> {{ parseFullDateToFr(retroplanning.config.date_start) }}</span>  
                                <span v-else>{{$t('immediate')}}</span>
                            </li>
                            <li v-if="retroplanning.config && retroplanning.config.spread"><b>{{$t('previsionnal_enddate')}} :</b> {{ getCampaignSpreadEndDate() }}</li>
                            <li v-if="retroplanning.type != 'MISSION'"><b>{{ $t('number_of_recipients') }} :</b> {{ retroplanning.config.contact_number }} </li>
                            <li v-if="retroplanning.type != 'MISSION'"><b>{{ $t('canal') }} :</b> {{ $t(retroplanning.config.canal) }}</li>
                        </ul>
                    </v-col>
                    <v-col cols="6">
                       <v-btn depressed color="success" :disabled="(retroplanning.config.contact_number) == 0 ? true : false || (retroplanning.sousType == 'campRCSout' && !asAgent) ? true : false || smsSenderInvalid" @click="program" :loading="loader">{{ $t('program') }}</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import GenericDataService from '@/services/GenericDataService'
import dateManipulation from '@/mixins/dateManipulation'

export default {
    name: "dialogProgramRpComponent",
    props: ['openProgramRpDialog', 'retroplanning', 'hasContactVar'],
    mixins:[dateManipulation],
    data() {
        return {
            loader:false,
            asAgent: false,
            smsSenderInvalid: false,
        }
    },
    mounted() {
        if(this.retroplanning.entity_id && this.retroplanning.entity_id.id){
            GenericDataService.getData('/entity/get?id=' + this.retroplanning.entity_id.id).then((response) => {
                this.asAgent = response.data.data.settings.rcs_agent ? true : false;
            });
        }
        this.fetchSmsSenderValidity();
    },
    watch: {
        openProgramRpDialog(val) {
            if(val) {
                this.fetchSmsSenderValidity();
            }
        },
        retroplanning: {
            handler() {
                this.fetchSmsSenderValidity();
            },
            deep: true
        }
    },
    computed: {
        nextDay(){
            let date = new Date();
            let hourLaunch = this.retroplanning.config.date_start.split(' ')[1];
            date.setDate(date.getDate() + 1); 
            date = date.toLocaleDateString();
            return date+' '+hourLaunch
        },
        smsConvWrongDate(){
            let nowDate = new Date();
            let today = new Date(nowDate.getFullYear()+'-'+(nowDate.getMonth()+1)+'-'+nowDate.getDate());
            let rpDay = new Date(this.retroplanning.config.date_start);
            return rpDay <= today
        }
    },  
    methods: {
        isSmsRetroplanning(){
            return this.retroplanning
                && ((this.retroplanning.type == 'CAMP_OUT_P' && this.retroplanning.sousType == 'campSMSout')
                || (this.retroplanning.type == 'CAMP_CALL' && this.retroplanning.sousType == 'campSMSconversational'));
        },
        getTemplateId(){
            if(this.retroplanning && this.retroplanning.config && this.retroplanning.config.template) {
                return this.retroplanning.config.template.id ? this.retroplanning.config.template.id : this.retroplanning.config.template;
            }
            return null;
        },
        setSmsSenderInvalid(senderValue){
            if(!senderValue) {
                this.smsSenderInvalid = false;
                return;
            }
            let length = String(senderValue).trim().length;
            this.smsSenderInvalid = length < 3 || length > 11;
        },
        fetchSmsSenderValidity(){
            this.smsSenderInvalid = false;
            if(!this.isSmsRetroplanning()) {
                return;
            }
            let templateId = this.getTemplateId();
            if(!templateId) {
                return;
            }
            GenericDataService.getData('/retroplanning/' + this.retroplanning.id + '/getCompiledTemplate?id=' + templateId).then((response) => {
                if(response.data.data && response.data.data.params_compiled && typeof response.data.data.params_compiled.sender !== 'undefined') {
                    this.setSmsSenderInvalid(response.data.data.params_compiled.sender);
                } else if(response.data.data && response.data.data.params && typeof response.data.data.params.sender !== 'undefined') {
                    this.setSmsSenderInvalid(response.data.data.params.sender);
                } else {
                    this.smsSenderInvalid = false;
                }
            }).catch(() => {
                this.smsSenderInvalid = false;
            });
        },
        dateToEpoch(thedate) {
            return thedate.getTime();
        },
        close() {
            this.$emit('close')
        },
        getCampaignSpreadEndDate() {
                if(this.retroplanning.config && this.retroplanning.config.date_start && new Date(this.retroplanning.config.date_start) < new Date()) {
                    let date = new Date();
                    date.setHours(date.getHours() + ((this.retroplanning.config.nb_packages - 1) * this.retroplanning.config.nb_hours));
                    return this.parseFullDateToFr(this.parseFullJsDateToUs(date));
                } else {
                    let date = new Date(this.retroplanning.config.date_start);
                    date.setHours(date.getHours() + ((this.retroplanning.config.nb_packages - 1) * this.retroplanning.config.nb_hours));
                    return this.parseFullDateToFr(this.parseFullJsDateToUs(date));
                }
        
        },
        program() {
            this.loader = true;
            GenericDataService.postData('/retroplanning/' + this.retroplanning.id + '/program').then((response) => {
                this.loader = false;
                this.$store.dispatch('ADD_SNACK', { message : this.$t('successActionConfirmed') }).then((e) => {
                    this.$store.dispatch("REMOVE_SNACK")
                });
                this.$emit('refresh');
            }).catch((error) => {
                this.loader = false
            });
        }
    },
}
</script>